module.exports = __webpack_public_path__ + "img/map-it.fe1c940a.png";